module.exports = __webpack_public_path__ + "static/media/no.24f55351.svg";